module.exports = __webpack_public_path__ + "static/media/success.451b871a.svg";